import { useEffect } from 'react';

import { isBrandTermActive } from 'src/data/brandTerm';
import { isSameLanguage } from 'src/data/generation';
import { useBrandTermsActions, useBrandVoicesAssets, useCurrentProject } from 'src/store';

export const useMaintainBrandRulesData = (language) => {
  const brandTermsActions = useBrandTermsActions();
  const { loadingBrandVoiceAssets, brandVoicesAssets } = useBrandVoicesAssets();
  const currentProject = useCurrentProject();

  useEffect(() => {
    if (loadingBrandVoiceAssets) {
      return;
    }

    const brandVoicesIds = brandVoicesAssets.reduce(
      (acc, item) => {
        if ((item.brandTerms?.filter(isBrandTermActive) || []).length > 0) {
          acc.withBrandRules.push(item.id);
        }
        acc.all.push(item.id);
        return acc;
      },
      { withBrandRules: [], all: [] }
    );

    // If we don't have any brand voice with brand rules, we should disable brand vocabulary
    if (brandVoicesIds.withBrandRules.length === 0) {
      brandTermsActions.setBrandVoiceIdsForBrandTerms([]);
      brandTermsActions.setBrandRulesEnabled(false);
      return;
    }

    const sameLanguageBrandVoiceIds = brandVoicesAssets
      .filter(
        (item) =>
          isSameLanguage(item.language, language) && brandVoicesIds.withBrandRules.includes(item.id)
      )
      .map((item) => item.id);

    // set selected brand voice ids for brand terms if the language is the same
    if (sameLanguageBrandVoiceIds) {
      brandTermsActions.setBrandVoiceIdsForBrandTerms(sameLanguageBrandVoiceIds);
      brandTermsActions.setBrandRulesEnabled(true);
    }
  }, [brandTermsActions, loadingBrandVoiceAssets, brandVoicesAssets, currentProject, language]);
};
